/** Tasks plan D9: `#/lists?task=<url-encoded text>` adds a task, the way
 *  `?recipe=` opens the grocery sheet. The router has already decoded the
 *  query (`router.ts`); this only says whether what arrived is a task.
 *  Trimmed, capped at 500 characters (a Shortcut that mis-wires a variable
 *  can send a page), empty is nothing. No imports, for the root suite. */
export const TASK_LINK_MAX = 500

export function taskFromQuery(query: Record<string, string>): string | null {
  const raw = query.task
  if (typeof raw !== 'string') return null
  const text = raw.trim().slice(0, TASK_LINK_MAX).trim()
  return text ? text : null
}
